module.exports = __webpack_public_path__ + "static/img/biz_login.bc8bdf0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pages/registerFlow/biz_login.svg
// module id = 57Vy
// module chunks = 30